import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  dangerousFileInputError: 'Dangerous file detected',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const FILE_INPUT_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    dangerousFileInputError: 'Archivo peligroso detectado',
  },
};

export default FILE_INPUT_LABELS;
